import React, { Component } from 'react';
import Card from '../../components/card/Card';
import Input from '../../inputs/input/Input';
import Button from '../../components/button/Button';
import './DrugOrderFormsPaginatedCard.css';
import history from '../../history';
import mainAPI from '../../api/MainAPI';
import utils from '../../utils/utils';
import CardHeader from '../../components/cardHeader/CardHeader';
import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import Label from '../../components/label/Label';
import CreateDrugOrderFormPopup from "../../popups/createDrugOrderFormPopup/CreateDrugOrderFormPopup";


class DrugOrderFormsPaginatedCard extends Component {
	static defaultProps = {
		displayNewFormButton: true,
		pageSize: 20
	};

	constructor(props) {
		super(props);
		this.storageKey = 'drugOrderFormsPaginatedSortPreference';
		this.currentRequestId = 0;
		this.tableRef = React.createRef();
		this.scrollContainerRef = React.createRef();
		

		this.VALID_ORDER_BY_OPTIONS = {
			'Form Number': 'drug_order_form.form_number',
			'Supplier DEA': 'drug_order_form.supplier_dea_number',
			'Type': 'drug_order_form.type',
			'Ordered On': 'drug_order_form.ordered_on',
			'Received On': 'drug_order_form.received_on',
			'Created': 'drug_order_form.created_on',
			'Created By': 'created_by_name'
		};
		

		const savedSortConfig = (() => {
			try {
				const item = localStorage.getItem(this.storageKey);
				return item ? JSON.parse(item) : { key: 'Created', direction: 'desc' };
			} catch (e) {
				return { key: 'Created', direction: 'desc' };
			}
		})();
		
		this.state = {
			search: '',
			forms: [],
			loading: false,
			loadingMore: false,
			currentPage: 1,
			totalPages: 1,
			totalCount: 0,
			hasMore: true,
			sortConfig: savedSortConfig
		};
		

		this.sortTableOptions = null;
	}

	_getSortTableOptions = () => {
		return {
			loadSortConfig: () => {
				return this.state.sortConfig;
			},
			onSortConfigSet: (config) => {
				localStorage.setItem(this.storageKey, JSON.stringify(config));
				this.setState({ sortConfig: config, currentPage: 1, forms: [] }, () => {
					this._loadForms(true);
				});
			}
		};
	};

	componentDidMount = () => {
		this._loadForms(true);
	};

	componentWillUnmount = () => {

		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}

		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}

		this._removeScrollListener();
	};


	_loadForms = async (reset = false) => {
		const { currentPage, search, sortConfig, loading, loadingMore, forms } = this.state;
		const { pageSize, filter = {} } = this.props;
		if(this.pendingRequest)return;

		if (loading || loadingMore) {
			return;
		}
		

		const requestId = ++this.currentRequestId;
		

		const apiOrderBy = this.VALID_ORDER_BY_OPTIONS[sortConfig.key] || 'drug_order_form.created_on';


		if (reset) {
			this.setState({ loading: true });
		} else {
			this.setState({ loadingMore: true });
		}
		
		try {
			const requestFilter = {
				...filter,
				page: currentPage,
				limit: pageSize,
				search: search,
				order_by: apiOrderBy,
				order_by_direction: sortConfig.direction
			};
			
			this.pendingRequest = mainAPI.drug_order_form.paginated(requestFilter);
			const response = await this.pendingRequest;
			this.pendingRequest = null;


			if (requestId !== this.currentRequestId) {
				return;
			}
			
			if (!response) {
				this.setState({
					forms: reset ? [] : forms,
					totalCount: 0,
					totalPages: 1,
					hasMore: false,
					loading: false,
					loadingMore: false
				});
				return;
			}
			

			const newForms = Array.isArray(response) ? response.filter(form => form != null) : [];
			

			const updatedForms = reset ? newForms : [...forms, ...newForms];
			

			const hasMore = newForms.length === pageSize;

			this.setState({
				forms: updatedForms,
				totalCount: updatedForms.length,
				totalPages: Math.ceil(updatedForms.length / pageSize),
				hasMore: hasMore,
				loading: false,
				loadingMore: false
			}, () => {

				if (reset && updatedForms.length > 0) {
					setTimeout(() => {
						this._setupScrollListener();
					}, 100);
				}
			});
		} catch (error) {

			if (requestId === this.currentRequestId) {
				console.error('Error loading drug order forms:', error);
				this.setState({ 
					forms: reset ? [] : forms,
					totalCount: 0,
					totalPages: 1,
					hasMore: false,
					loading: false,
					loadingMore: false
				});
			}
		}
	};


	_searchChange = (search) => {
		this.setState({ search, currentPage: 1, forms: [] }, () => {

			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this._loadForms(true);
			}, 300);
		});
	};

	_navigateToFormDetailsPage = (form) => {
		if (!form || !form.id) {
			console.warn('Cannot navigate: form or form.id is null/undefined');
			return;
		}
		history.navigate('/drug_order_form/' + form.id);
	};

	_showCreateModal = () => {
		window.popupController.show(CreateDrugOrderFormPopup, {
			onClose: () => {
				window.popupController.hide(CreateDrugOrderFormPopup);
				this._loadForms(true);
			}
		});
	};

	_setupScrollListener = () => {
		this.scrollHandler = this._debounceScroll.bind(this);

		if (this.scrollContainerRef.current) {
			this.scrollContainerRef.current.addEventListener('scroll', this.scrollHandler, { passive: true });
			

			setTimeout(() => {
				if (this.scrollContainerRef.current) {
					this.scrollContainerRef.current.scrollTop = 1;
					setTimeout(() => {
						if (this.scrollContainerRef.current) {
							this.scrollContainerRef.current.scrollTop = 0;
						}
					}, 500);
				}
			}, 1000);
		} else {
			setTimeout(() => {
				if (this.scrollContainerRef.current) {
					this.scrollContainerRef.current.addEventListener('scroll', this.scrollHandler, { passive: true });
				} else {
				}
			}, 100);
		}
	};

	_debounceScroll = () => {

		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}


		this.scrollTimeout = setTimeout(() => {
			this._handleScroll();
		}, 100);
	};

	_removeScrollListener = () => {
		if (this.scrollHandler && this.scrollContainerRef.current) {
			this.scrollContainerRef.current.removeEventListener('scroll', this.scrollHandler);
		}
	};

	_handleScroll = () => {
		const { loadingMore, hasMore, currentPage } = this.state;



		if (loadingMore || !hasMore) {

			return;
		}




		const scrollContainer = this.scrollContainerRef.current;
		if (!scrollContainer) {

			return;
		}


		const scrollTop = scrollContainer.scrollTop;
		const scrollHeight = scrollContainer.scrollHeight;
		const clientHeight = scrollContainer.clientHeight;



		if (scrollHeight > clientHeight && scrollTop + clientHeight >= scrollHeight - 100) {


			this.setState({ currentPage: currentPage + 1 }, () => {
				this._loadForms(false);
			});
		}
	};

	_formatFormsForTable = () => {
		const { forms } = this.state;


		if (!Array.isArray(forms) || forms.length === 0) {
			return [];
		}

		return forms.map((form, index) => {

			if (!form) {
				return null;
			}

			const orderedOnDate = form.ordered_on ? utils.server_to_client_date(form.ordered_on) : null;
			const orderedOnDisplay = (orderedOnDate && utils.is_date(orderedOnDate)) ? utils.display_date(utils.server_to_client_datetime(form.ordered_on)) : '';

			const receivedOnDate = form.received_on ? utils.server_to_client_date(form.received_on) : null;
			const receivedOnDisplay = (receivedOnDate && utils.is_date(receivedOnDate)) ? utils.display_date(utils.server_to_client_datetime(form.received_on)) : '';

			const createdOnDate = form.created_on ? utils.server_to_client_date(form.created_on) : null;
			const createdOnDisplay = (createdOnDate && utils.is_date(createdOnDate)) ? utils.display_date(utils.server_to_client_datetime(form.created_on)) : '';

			const rowData = [
				{ column: "Form Number", value: form.form_number || '' },
				{ column: "Supplier DEA", value: form.supplier_dea_number || '' },
				{ column: "Type", value: form.type || '' },
				{ column: "Ordered On", value: orderedOnDisplay, children: orderedOnDisplay },
				{ column: "Received On", value: receivedOnDisplay, children: receivedOnDisplay },
				{ column: "Created", value: createdOnDisplay, children: createdOnDisplay },
				{ column: "Created By", value: form.created_by_name || '' }
			];

			return {
				data: rowData,
				onClick: () => this._navigateToFormDetailsPage(form)
			};
		}).filter(row => row !== null);
	};


	_getColumnWidths = () => {

		return {
			'Form Number': '15%',
			'Supplier DEA': '15%',
			'Type': '15%',
			'Ordered On': '15%',
			'Received On': '15%',
			'Created': '15%',
			'Created By': '10%'
		};
	};

	_renderSortableTableHeader = (tableData) => {
		const headers = tableData && tableData.length > 0
			? tableData[0].data.map(r => r.column)
			: Object.keys(this.VALID_ORDER_BY_OPTIONS);
		
		const sortOptions = this._getSortTableOptions();
		const sortConfig = sortOptions.loadSortConfig();
		const columnWidths = this._getColumnWidths();
		
		const renderHeader = (header, index) => {
			return (
				<TableCell 
					key={index}
					style={{ width: columnWidths[header] || 'auto' }}
				>
					<TableSortLabel
						active={sortConfig.key === header}
						direction={sortConfig.key === header ? sortConfig.direction : 'asc'}
						onClick={() => sortOptions.onSortConfigSet({
							key: header,
							direction: sortConfig.key === header && sortConfig.direction === 'asc' ? 'desc' : 'asc'
						})}
					>
						<Label black bold>{header}</Label>
					</TableSortLabel>
				</TableCell>
			);
		};

		return (
			<Table>
				<TableHead>
					<TableRow>{headers.map(renderHeader)}</TableRow>
				</TableHead>
			</Table>
		);
	};

	_renderSortableTableBody = (tableData, loading) => {
		if (!tableData || tableData.length === 0) return null;
		
		const headers = tableData[0].data.map(r => r.column);
		const columnWidths = this._getColumnWidths();
		
		const renderRow = (row = {}, index) => {
			const { data: rowObjects = [], onClick = (() => {}) } = row;
			const values = headers.map(header => {
				const cell = rowObjects.find(d => d.column === header) || {};
				const { value, children } = cell;
				return children ? children : value;
			});
			
			return (
				<TableRow onClick={onClick} key={index}>
					{values.map((value, i) => (
						<TableCell 
							key={i}
							style={{ width: columnWidths[headers[i]] || 'auto' }}
						>
							{value}
						</TableCell>
					))}
				</TableRow>
			);
		};

		return (
			<div 
				ref={this.scrollContainerRef}
				className="drug-order-form-table-body-container"
			>
				<Table>
					<TableBody>
						{tableData.map(renderRow)}
					</TableBody>
				</Table>
				{this._renderInfiniteScrollIndicator(loading)}
			</div>
		);
	};

	_renderInfiniteScrollIndicator = (loading) => {
		const { loadingMore, hasMore, forms } = this.state;
		if(loading){
			return <div className="infinite-scroll-loading">
				Loading...
			</div>
		}
		if (loadingMore) {
			return (
				<div className="infinite-scroll-loading">
					Loading more forms...
				</div>
			);
		}
		
		if (!hasMore && forms.length > 0) {
			return (
				<div className="infinite-scroll-end">
					Nothing more to load
				</div>
			);
		}
		
		return null;
	};

	render() {
		const { loading, forms } = this.state;
		const { title, displayNewFormButton } = this.props;
		
		const tableData = this._formatFormsForTable();
		const hasData = Array.isArray(forms) && forms.length > 0;

		return (
			<Card className={'g-drug-order-forms-paginated-card'}>
				<div className="top-of-card">
					<CardHeader>{title || 'Drug Order Forms (Infinite Scroll)'}</CardHeader>
					<div className="top-of-card-right">
						<Input
							iconName="icon-search"
							placeholder="Search Form Number, Supplier DEA, Type or Created By"
							onChange={this._searchChange}
						/>
					</div>
					{displayNewFormButton && (
						<Button 
							onClick={this._showCreateModal} 
							className="top-of-card-right-button" 
							color="white" 
							bg="blue"
						>
							+ New Form
						</Button>
					)}
					{this.props.children}
				</div>
				<div className="drug-order-form-table-wrapper">
					{this._renderSortableTableHeader(tableData)}
					{hasData && (
						this._renderSortableTableBody(tableData, loading)
					)}
				</div>

			</Card>
		);
	}
}

export default DrugOrderFormsPaginatedCard;




// WEBPACK FOOTER //
// ./src/cards/drugOrderFormsPaginatedCard/DrugOrderFormsPaginatedCard.jsx